<template>
  <div class="fee-receipt-settings">
     
      <v-row>
        <v-col cols="12" md="8">
          <h1 class="text-left mx-4 mt-2">Fee Receipt Settings</h1>
          <h5 class="text-left mx-4">{{ activeFeeSession.title }}</h5>
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            :to="{ name: 'AddFeeReceiptSettings' }"
            color="primary"
            class="mx-4 mt-2"
          >Add Fee Receipt Settings</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="!isLoading && !receiptSettings.length > 0">
          <h2>No Fee Receipt Settings Found</h2>
        </v-col>
        <v-col v-else cols="12" md="4" v-for="setting in receiptSettings" :key="setting.id">
          <v-card
            class="py-4 mx-4 my-2 px-4"
            :to="{ name: 'EditFeeReceiptSettings', params: {id: setting.id}}"
          >
            <h2 class="text-left font-weight-medium mb-4">{{ setting.title }}</h2>
            <!-- <p class="text--secondary text-left font-weight-medium mb-0">
              <small>{{ particular.title }}</small>
            </p> -->
          </v-card>
        </v-col>
      </v-row>
     
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import TourHelper from "@utils/tour_helper";


export default {
  name: "FeeReceiptSettings",
  data() {
    return {
      receiptSettings: [],
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isLoading", "accessToken","activeFeeSession"]),
    essentials() {
      return {
        setLoading: this.setLoading,
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
      var steps = [];
      steps.push({id: '1', title: "Welcome to Fee Reciept Settings!", description: "Create and Edit all your Fee Reciept Settings in this page", videoLink: "https://youtube.com"});
      // steps.push({id: '2', title: "Filter Classroom", description: "Access Students from their Classroom", el: '#add-student',position:'left'});
      TourHelper.startTour(this, "fee__reciept", steps);
    },


    // queries all particulars from the database
    async getAllReceiptSettings() {
      var response;
      var url = endpoints.getFeeReceiptSettings;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });
      if (response) {
        this.receiptSettings = response;
      }
    },
    // handles api errors
    async handleApiErrors(err) {
      console.log(err);
      this.setLoading(false);
    },
  },
  created() {
    this.handleTour();
    this.getAllReceiptSettings();
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>